import React from 'react';
import classnames from 'classnames';
import FilePicker from '../file-picker';
import FieldStatus from '../../../field-status';
import { SIZES } from '../../constants';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
const ImagePickerPreview = ({
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  imageSource = null,
  size = SIZES.small,
  invalid = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undefined'.
  statusText = null,
  disabled = false,
  ...restProps
}) => {
  const imagePreviewClasses = classnames(
    'ws-ui-image-picker-preview',
    `ws-ui-image-picker-preview--${size}`,
    { 'ws-ui-image-picker-preview--disabled': disabled }
  );

  const statusPaddingClass = imageSource && 'ws-ui-image-picker-preview__status-wrapper-padding';
  const appearance = invalid ? 'error' : 'default';

  return (
    <div className={imagePreviewClasses}>
      <div className="ws-ui-image-picker-preview__container">
        {imageSource && (
          <div className="ws-ui-image-picker-preview__preview">
            <img src={imageSource} className="ws-ui-image-picker-preview__image" alt="" />
          </div>
        )}
        <div className="ws-ui-image-picker-preview__picker-wrapper">
          {/* @ts-ignore TS(2741): Property 'label' is missing in type '{ invalid: bo... Remove this comment to see the full error message */}
          <FilePicker invalid={invalid} size={size} disabled={disabled} {...restProps} />
        </div>
      </div>
      {statusText && (
        <div className={statusPaddingClass}>
          <FieldStatus appearance={appearance} text={statusText} />
        </div>
      )}
    </div>
  );
};

export default ImagePickerPreview;
